import { News } from "../domain/news";
import { getAllNewsService } from "../infrastructure/services/getAllNewsService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const getAllNews = {
    async execute(): Promise<News[]> {
        return await getAllNewsService.execute(await tokenValidation.execute());
    },
};


